import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get, post, puto, patch} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import MyInvoisActions from '../MyInvois/actions';

// Create company
export function* createRequest() {
    yield takeEvery(actions.COMPANY_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/companies', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.COMPANY_CREATE_SUCCESS,
                company: data.company,
            });
        }
        catch (error) {
            yield put({
                type: actions.COMPANY_CREATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createSuccess() {
    yield takeEvery(actions.COMPANY_CREATE_SUCCESS, function* () {
        yield message.success(t`New company is created.`);
    });
}
export function* createError() {
    yield takeEvery(actions.COMPANY_CREATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read company
export function* readCompanyRequest() {
    yield takeEvery(actions.READ_COMPANY_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            let data = null;

            const { data: payloadData } = payload;
            if (payload.data) {
                data = payloadData;
            }
            else {
                // const responseCompany = yield call(get, '/companies/current', null, context);
                // const dataCompany = yield responseCompany.data;
                const responseProfile = yield call(get, '/companies/current/profile', null, context);
                const dataProfile = yield responseProfile.data;
                data = {
                    company: {
                        // ...dataCompany.company,
                        ...dataProfile.profile,
                    },
                };
            }

            yield put({
                type: actions.READ_COMPANY_SUCCESS,
                company: data.company,
            });

            yield put({
                type: MyInvoisActions.MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT,
                isValid: data.company.is_myinvois_validated,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_COMPANY_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readCompanySuccess() {
    yield takeEvery(actions.READ_COMPANY_SUCCESS, () => {});
}

// Read my invois
export function* readMyInvoisReadyRequest() {
    yield takeEvery(actions.READ_MY_INVOIS_READY_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/companies/current/profile/is_myinvois_ready', null, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_MY_INVOIS_READY_SUCCESS,
                isMyInvoisReady: data.is_myinvois_ready,
                myInvoisReadyInvalidFields: data.invalid_fields,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_MY_INVOIS_READY_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readMyInvoisReadySuccess() {
    yield takeEvery(actions.READ_MY_INVOIS_READY_SUCCESS, () => {});
}

export function* readCompanyError() {
    yield takeEvery([
        actions.READ_COMPANY_ERROR,
        actions.READ_MY_INVOIS_READY_ERROR,
        actions.READ_COMPANY_LIST_ERROR,
    ], function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read company list
export function* readCompanyListRequest() {
    yield takeEvery(actions.READ_COMPANY_LIST_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/companies', null, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_COMPANY_LIST_SUCCESS,
                companies: data.companies,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_COMPANY_LIST_ERROR,
                error,
            });
        }
    });
}

// Update company
export function* updateCompanyRequest() {
    yield takeEvery(actions.UPDATE_COMPANY_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            console.log("Saga request:", request);
            const response = yield call(puto, '/companies/current/profile', request, context);
            console.log("Saga response:", response);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_COMPANY_SUCCESS,
                company: data.company,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_COMPANY_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateCompanySuccess() {
    yield takeEvery(actions.UPDATE_COMPANY_SUCCESS, function* () {
        yield message.success(t`Company profile is updated.`);
    });
}
export function* updateCompanyError() {
    yield takeEvery(actions.UPDATE_COMPANY_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Patch company msic code
export function* patchMsicCodeRequest() {
    yield takeEvery(actions.PATCH_MSIC_CODE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(patch, '/companies/current/profile', request, context);
            const data = yield response.data;
            // OK
            yield put({
                type: actions.PATCH_MSIC_CODE_SUCCESS,
                msicCode: data.company.msic_code,
            });
        }
        catch (error) {
            yield put({
                type: actions.PATCH_MSIC_CODE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export function* patchMsicCodeSuccess() {
    yield takeEvery(actions.PATCH_MSIC_CODE_SUCCESS, function* () {
        yield message.success(t`Your MSIC code is updated`);
    });
}

export function* patchMsicCodeError() {
    yield takeEvery(actions.PATCH_MSIC_CODE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Reset company
export function* resetRequest() {
    yield takeEvery(actions.COMPANY_RESET_REQUEST, function* ({ subdomain, password }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            context.allow_intercept = true;
            yield call(post, '/companies/current/reset', {
                secret: subdomain,
                password,
            }, context);

            // OK
            yield put({
                type: actions.COMPANY_RESET_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.COMPANY_RESET_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* resetSuccess() {
    yield takeEvery(actions.COMPANY_RESET_SUCCESS, function* () {
        yield message.success(t`All account data has been reset.`);
    });
}
export function* resetError() {
    yield takeEvery(actions.COMPANY_RESET_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createRequest),
        fork(createSuccess),
        fork(createError),

        fork(readCompanyListRequest),
        fork(readCompanyRequest),
        fork(readCompanySuccess),
        fork(readCompanyError),
        fork(readMyInvoisReadyRequest),
        fork(readMyInvoisReadySuccess),
        fork(updateCompanyRequest),
        fork(updateCompanySuccess),
        fork(updateCompanyError),
        fork(resetRequest),
        fork(resetSuccess),
        fork(resetError),
        fork(patchMsicCodeRequest),
        fork(patchMsicCodeSuccess),
        fork(patchMsicCodeError),
    ]);
}
